import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import LoginPage from './containers/Login';
import SignupPage from 'containers/Signup';
import PrivateRoute from 'containers/PrivateRoute';
import GuidePage from 'containers/Guide';
import SettlementPage from 'containers/Settlement';
import SettlementRegistPage from 'containers/SettlementRegist';

import {
  GUIDE_PATH,
  LOGIN_PATH,
  SETTLEMENT_PATH,
  SETTLEMENT_REGIST_PATH,
  SETTLEMENT_BANK_REGIST_PATH,
  SIGNUP_PATH,
  SETTLEMENT_REQUEST_PATH,
  SETTLEMENT_DETAIL_PATH,
  PRODUCT_REGIST_PATH,
  PRODUCT_LIST_PATH,
  PRODUCT_DETAIL_PATH,
  MESSAGE_LIST_PATH,
  QNA_LIST_PATH,
  REVIEW_LIST_PATH,
  MENU_PATH,
  SALE_LIST_PATH,
  NOTICE_PATH,
  SALE_DETAIL_PATH,
  BOOKING_LIST_PATH,
  PROFILE_PATH,
  INDIVIDUAL_PATH,
  NOTICE_DETAIL_PATH,
  START_PATH,
  SETTLEMENT_REQUEST_LIST_PATH,
  SETTLEMENT_LIST_PATH,
  FIND_PASSWORD_PATH,
  DELIVERY_PATH,
} from 'constants/path';
import SettlementBankRegistPage from 'containers/SettlementBankRegist';
import SettlementDetailPage from 'containers/SettlementDetail';
import { useGetMe } from 'graphQL/Auth/user/useGetMe';
import ProductRegistPage from 'containers/ProductRegist';
import { STORAGE_KEY } from 'utils/localStoarge';
import {
  callWebviewHandler,
  isWebview,
  WebviewOperatorType,
} from 'utils/webview';
import ProductListPage from 'containers/ProductList';
import ProductDetailPage from 'containers/ProductDetail';
import MessageListPage from 'containers/MessageList';
import QnAListPage from 'containers/QnaList';
import ReviewListPage from 'containers/ReviewList';
import MenuPage from 'containers/Menu';
import SaleListPage from 'containers/SaleList';
import NoticePage from 'containers/Notice';
import SaleDetailPage from 'containers/SaleDetail';
import BookingListPage from 'containers/BookingList';
import ProfilePage from 'containers/Profile';
import IndividualPage from 'containers/Profile/Individual';
import NoticeDetailPage from 'containers/NoticeDetail';
import ToastManager from 'components/Modal/ToastManager';
import GuideContent from 'containers/Guide/components/GuideContent';
import Loading from 'components/Loading/Loading';
import NavigateLoading from 'components/Loading/NavigateLoading';
import SettlementRequestListPage from 'containers/SettlementRequestList';
import SettlementRequestPage from 'containers/SettlementRequest';
import SettlementListPage from 'containers/SettlementList';
import FindPasswordContainer from 'containers/FindPassword';
import DeliveryContainer from 'containers/Delivery';
import { HEADER_HEIGHT } from 'constants/style';
import { useIsMobile } from 'hooks/common';

const AppLayOut = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 100%;

  /* min-height: 100vh;
  height: 100%; */
  /* height: calc(100vh - 57px); */

  height: 100%;
  /* min-height: calc(100vh - 57px - 101px); */
  min-height: 100vh;
  /* min-height: calc(100vh - 57px); */

  /* padding-top: ${HEADER_HEIGHT}px; */

  background-color: #f7f7f8;

  @media (max-width: 768px) {
    padding-top: 0px;
  }
`;

export const MAX_WIDTH = 768;

function App() {
  const { handleGetUserInformation, handleRefetchUser } = useGetMe();

  const [loading, setLoading] = useState<boolean>(true);
  const isMobile = useIsMobile();

  const handleSetAuthorization = (param: { authToken: string }) => {
    if (localStorage.getItem(STORAGE_KEY.AUTHORIZATION) !== param.authToken) {
      localStorage.removeItem(STORAGE_KEY.AUTHORIZATION);
    }

    localStorage.setItem(STORAGE_KEY.AUTHORIZATION, param.authToken);
    window.__INIT_AUTHORIZATION__ = param.authToken;

    handleRefetchUser(() => {
      setLoading(false);
    });
  };

  const handleSetHostAdminStart = () => {
    setLoading(false);
    // alert('setLoading false');
  };

  const handleSetIsHostAdminApp = (isHostAdmin: boolean) => {
    if (isHostAdmin) {
      localStorage.setItem(STORAGE_KEY.IS_HOST_ADMIN_APP, 'Y');
    }
  };

  useEffect(() => {
    if (isWebview()) {
      callWebviewHandler(WebviewOperatorType.SetAuthorizationHandler);
      setLoading(true);
    }

    handleGetUserInformation();
    window.handleSetAuthorization = handleSetAuthorization;
    window.handleSetHostAdminStart = handleSetHostAdminStart;
    window.handleSetIsHostAdminApp = handleSetIsHostAdminApp;
  }, []);

  if (isWebview() && loading) {
    return <Loading />;
  }

  return (
    <AppLayOut $isMobile={isMobile}>
      <NavigateLoading />
      <ToastManager />
      <BrowserRouter>
        <Routes>
          <Route path={LOGIN_PATH} element={<LoginPage />} />
          <Route path={SIGNUP_PATH} element={<SignupPage />} />
          <Route
            path={FIND_PASSWORD_PATH}
            element={<FindPasswordContainer />}
          />
          <Route path={GUIDE_PATH} element={<GuidePage />} />
          <Route path={START_PATH} element={<GuideContent />} />
          <Route element={<PrivateRoute />}>
            <Route
              path="/"
              element={<Navigate replace to={BOOKING_LIST_PATH} />}
            />
            <Route path={SALE_LIST_PATH} element={<SaleListPage />} />
            <Route
              path={`${SALE_DETAIL_PATH}/:id`}
              element={<SaleDetailPage />}
            />
            <Route path={BOOKING_LIST_PATH} element={<BookingListPage />} />
            <Route path={PRODUCT_LIST_PATH} element={<ProductListPage />} />
            <Route
              path={`${PRODUCT_REGIST_PATH}/:id`}
              element={<ProductRegistPage />}
            />
            <Route
              path={`${PRODUCT_DETAIL_PATH}/:id`}
              element={<ProductDetailPage />}
            />
            <Route path={MENU_PATH} element={<MenuPage />} />
            <Route
              path={SETTLEMENT_REQUEST_PATH}
              element={<SettlementRequestPage />}
            />
            <Route path={SETTLEMENT_PATH} element={<SettlementPage />} />
            <Route
              path={SETTLEMENT_REGIST_PATH}
              element={<SettlementRegistPage />}
            />
            <Route
              path={SETTLEMENT_BANK_REGIST_PATH}
              element={<SettlementBankRegistPage />}
            />
            <Route
              path={SETTLEMENT_LIST_PATH}
              element={<SettlementListPage />}
            />
            <Route
              path={SETTLEMENT_DETAIL_PATH}
              element={<SettlementDetailPage />}
            />
            <Route
              path={SETTLEMENT_REQUEST_LIST_PATH}
              element={<SettlementRequestListPage />}
            />
            <Route path={MESSAGE_LIST_PATH} element={<MessageListPage />} />
            <Route path={QNA_LIST_PATH} element={<QnAListPage />} />
            <Route path={REVIEW_LIST_PATH} element={<ReviewListPage />} />
            <Route path={NOTICE_PATH} element={<NoticePage />} />
            <Route
              path={`${NOTICE_DETAIL_PATH}/:id`}
              element={<NoticeDetailPage />}
            />
            <Route path={PROFILE_PATH} element={<ProfilePage />} />
            <Route path={INDIVIDUAL_PATH} element={<IndividualPage />} />
            <Route path={DELIVERY_PATH} element={<DeliveryContainer />} />
          </Route>
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </BrowserRouter>
    </AppLayOut>
  );
}

export default App;
